module.exports = __webpack_public_path__ + "static/media/screenshot-10.917b4246.png";